import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/layout/Header";
import HomePage from "@/pages/HomePage";
import EditorPage from "@/pages/EditorPage";
import GalleryPage from "@/pages/GalleryPage";
import TemplatesPage from "@/pages/TemplatesPage";
import AdminPage from "@/pages/AdminPage";
import AdminEditPage from "@/pages/AdminEditPage";
import MemePage from "@/pages/MemePage";
import CategoryPage from "@/pages/CategoryPage";

const AppContent = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/edit/:slug" element={<AdminEditPage />} />
        <Route path="/meme/:slug" element={<MemePage />} />
        <Route path="/category/:category" element={<CategoryPage />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="app-container">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </AuthProvider>
  );
}

export default App;
